import { createHashHistory } from 'history'

export default createHashHistory({
  /* pass a configuration object here if needed */
})